// varticval navigation section

$('.nav_vertical .sidenav a').on('click', function (e) { 
  e.preventDefault(); 
  var currentUrl = $(location).attr('href');
  console.log(currentUrl);
  var url = new URL(currentUrl);
  console.log(url);
  var queryval = $(this).attr("data-href");
  console.log(queryval);
  if(queryval.includes('/pages/loyalty-points')){
      // debugger;
      window.location.pathname = '/pages/loyalty-points';
  }else{
  history.pushState({ path: queryval }, '', queryval);
// debugger;
  updatePageContent(queryval);
  }
});

function updatePageContent(path) {
    $.ajax({
      url: path, 
      success: function(response) {
        // debugger;
        var parser = new DOMParser();
      var doc = parser.parseFromString(response, "text/html");

      var mainContent = doc.querySelector('body main .order_informationcust_data') ? doc.querySelector('body main .order_informationcust_data').innerHTML : '<p>Main content not found.</p>';
// console.log(mainContent);
document.querySelector('body main .order_informationcust_data').innerHTML = mainContent;
          // $('#content').html(response);
      },
      error: function() {
          console.log("Error fetching the content");
      }
  });
}

window.onpopstate = function(event) {
  if (event.state) {
      updatePageContent(event.state.path);
  }
};

// customer information updates section

$(document).ready(function(){
  // debugger;
      // $('#togglePassword').click(function(){  
          $(document).on('click', '.order_informationcust_data #togglePassword', function(e) {
      // debugger;
        var passwordField = $('#CustomerPassword');
        var passwordFieldType = passwordField.attr('type');
        if (passwordFieldType === 'password') {
          passwordField.attr('type', 'text');
          $(this).addClass('hide_password');
        } else {
          passwordField.attr('type', 'password');
          $(this).removeClass('hide_password');
        }
      });
  
      // $('#toggleRepeatPassword').click(function(){
          $(document).on('click', '.order_informationcust_data #toggleRepeatPassword', function(e) {
        var passwordRepeatField = $('#customerRepeatPassword');
        var passwordFieldTypeRepeat = passwordRepeatField.attr('type');
        if (passwordFieldTypeRepeat === 'password') {
          passwordRepeatField.attr('type', 'text');
          $(this).addClass('hide_password');
        } else {
          passwordRepeatField.attr('type', 'password');
          $(this).removeClass('hide_password');
        }
      });
  });

function infodatacustom(){
$(document).ready(function(){
// debugger;
  if (window.location.pathname === '/pages/information-page') {

// 10-08-2024 Nidhi
// phone numbaer validation start
var phoneInput = document.querySelector('input[name="customer[phone]"]');
      var iti = window.intlTelInput(phoneInput, {
          utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.3/build/js/utils.js",
          // utilsScript: "{{ 'utils.js' | asset_url }}", 
          separateDialCode: true,
          initialCountry: "auto", // Automatically detect the user's country
      });

      // Validate the phone number when the input loses focus (on blur)
      phoneInput.addEventListener("blur", function() {
          var validationResult = document.querySelector("#validationResult");
          if (iti.isValidNumber()) {
              var validNumber = iti.getNumber(); // Get the full international number
              validationResult.innerHTML = `Valid phone number: ${validNumber}`;
              validationResult.style.color = "green";
              validationResult.classList.add('valid_number');
          } else {
              validationResult.innerHTML = "Invalid phone number.";
              validationResult.style.color = "red";
              validationResult.classList.add('notvalid_number');
          }
      });

$(function(){
$('input[name="customer[phone]"]').on('input', function (e) {
  $(this).val($(this).val().replace(/[^0-9]/g, ''));
});
});
// phone number end

document.getElementById('birthdate').max = new Date().toISOString().split("T")[0];
}
});
}

// window.addEventListener('load', () => {
//     // debugger;
//     typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
//   });

function UpdateInformation(event) {
// debugger;
var password = document.querySelector('input[name="customer[password]"]').value;
var cpassword = document.querySelector('input[name="customerRepeat[password]"]').value;
var errorMessage = document.getElementById('errorMessage'); // Ensure you have this element in your HTML

if (password !== cpassword) {
  event.preventDefault(); // Prevent form submission
  errorMessage.textContent = "Passwords do not match!";
} else if (document.querySelector('#validationResult').classList.contains('notvalid_number')) {
  event.preventDefault(); // Prevent form submission for invalid number
  // errorMessage.textContent = "Invalid phone number!";
}
 else {
  errorMessage.textContent = "";
  var button = event.target;
  var originalText = button.innerText;
  button.innerText = "Loading...";

  var country_selector = document.querySelector('.iti__selected-flag .iti__selected-dial-code').textContent;
  var DataObj = {
    customerId: document.querySelector('input[name="customer_id"]').value,
    firstName: document.querySelector('input[name="customer[first_name]"]').value,
    lastName: document.querySelector('input[name="customer[last_name]"]').value,
    phone: document.querySelector('input[name="customer[phone]"]').value.replace(' ', ''),
    email: document.querySelector('input[name="customer[email]"]').value,
    countryCode: country_selector,
    birthDate: document.querySelector('input[name="customer[Birthday]"]').value,
    isReciveMarketingEmail: document.getElementById('marketing_emails').checked
  };

  if (password.length !== 0) {
    DataObj.password = password;
  }

  fetch('https://api-flower-kikz.aliansoftware.net/api/v1/userUpdate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(DataObj)
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(data => {
    console.log('Success:', data);
  //   debugger;
    document.getElementById('display_message').textContent = "successfully data updates..."
    if(document.querySelector('input[name="customer[password]"]').value != '' || document.querySelector('input[name="customerRepeat[password]"]').value != '' ){
      window.location.href = "/account/login";
    }
    // Handle success here (e.g., show a success message)
  })
  .catch((error) => {
    console.error('Error:', error);
    // Handle error here (e.g., show an error message)
  })
  .finally(() => {
           button.innerText = originalText;
   
  });
}
}

window.addEventListener('load', () => {
  // debugger;
  if (window.location.pathname === '/pages/information-page') {
  infodatacustom();
  }
});

$('.myinformations').on('click' , function(){
//  debugger;
setTimeout(function(){
  infodatacustom();
}, 1500);

});


// address

window.addEventListener('load', () => {
  typeof CustomerAddresses !== 'undefined' && new CustomerAddresses();
});

 $('.mydeliveryaddress').on('click' , function(){
    //   debugger;
    setTimeout(function(){
      $('select[name="address[country]"].country_select option').removeAttr('selected');
      var option_select = $('select[name="address[country]"].country_select').attr('data-default');
      $('select[name="address[country]"].country_select option').each(function(){
          var option_val = $(this).attr('value');
          if(option_val == option_select){
              $(this).attr('selected' , 'selected')
          }
      })
    }, 1500);
      });

// Gift cart

function giftcartcall(){

  $('#loader_onload_event').hide();
if(document.querySelector('input[name="customer_id"]')!=null){ 
 fetch('https://api-flower-kikz.aliansoftware.net/api/v1/getGiftCard', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({
    customerId : document.querySelector('input[name="customer_id"]').value,
  })
})
.then(response => response.json())
.then(data => {
//   debugger;
  console.log('Success:', data);

  if(data.message.length > 0){
      $('.order_informationcust_data .custom_gift_data_call').show();
      $('.order_informationcust_data .customer.addresses_gift').hide();
  }else{
      $('.order_informationcust_data .customer.addresses_gift').show();
      $('.order_informationcust_data .custom_gift_data_call').hide();
  }

  var totalCardAmount = 0;
  var detailsHTML = '';
  var gift_cart_currency = '';
for( let i in data.message ){
  console.log(data.message[i]);
var customerId = data.message[i].customerId;
var giftCardCurrency = data.message[i].giftCardCurrency;
var giftCardId = data.message[i].giftCardId;
var id =  data.message[i].id;
var lastCharacters = data.message[i].lastCharacters;
var maskNumber = data.message[i].maskNumber;
var productId = parseInt(data.message[i].productId);
var spendAmount = data.message[i].spendAmount;
var totalGiftCardAmount = data.message[i].totalGiftCardAmount;
var userId =  data.message[i].userId;
var variantId = data.message[i].variantId;
var remaining_ammount = totalGiftCardAmount - spendAmount;
totalCardAmount = totalCardAmount + remaining_ammount;
var gift_cart_currency = data.message[i].giftCardCurrency;
{/* <p>Gift Card ID: ${giftCardId}</p> */}
detailsHTML += `<div class="gift_cart_info"><div class="gift_cart_box">
            <img src="//flowerkickz.gr/cdn/shop/files/Logo_1.svg?v=1717568003" alt="Logo">
             <div class="content"> <p>Last Characters: ${lastCharacters}</p>
              <p>Spend Amount: ${spendAmount} ${data.message[i].giftCardCurrency}</p>
              <p>Total Amount: ${totalGiftCardAmount.toLocaleString()} ${data.message[i].giftCardCurrency}</p></div>
              </div></div>`;
              

//  if(document.querySelector('.totalGiftCardAmount') != null){ document.querySelector('.totalGiftCardAmount').innerText = totalGiftCardAmount; }
// if(document.querySelector('.lastCharacters') != null){ document.querySelector('.lastCharacters').innerText = lastCharacters; }

//   if(document.querySelector('.totalammountgift') != null){
//   document.querySelector('.totalammountgift').innerText = customerId + "<br>" + giftCardCurrency + "<br>" + giftCardId + "<br>" + id  + "<br>"
//   + lastCharacters + "<br>" + maskNumber + "<br>" + productId + "<br>" + spendAmount + "<br>" + totalGiftCardAmount + "<br>" +
//   userId + "<br>" + variantId;
//   } 
};

var productGiftDiv = document.querySelector('.product_gift_details');
if (productGiftDiv) {
    productGiftDiv.innerHTML = detailsHTML;
}

 // Function to initialize the slick slider
 function initializeSlickSlider() {
  if (!$('.product_gift_details').hasClass('slick-initialized')) {
    $('.product_gift_details').slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      infinite: false,
      responsive: [
        {
          breakpoint: 990,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
}
initializeSlickSlider();
$('.nav-item.giftcard').on('click', function() {
  setTimeout(function() {
    initializeSlickSlider();
  }, 500);
});

if(document.querySelector('.totalammountgift') != null){ document.querySelector('.totalammountgift').innerText = totalCardAmount + gift_cart_currency; }
})
.catch((error) => {
  console.error('Error:', error);
});
  }
}

window.addEventListener('load', () => {
  // debugger;
giftcartcall();
});

$('.giftcard').on('click' , function(){
//   debugger;
setTimeout(function(){
giftcartcall();
}, 1500);
});

//   account main
// debugger;
$(document).ready(function () {
  // $('.open_model_order').click(function () {
      $(document).on('click', '.order_informationcust_data .open_model_order', function(e) {
        
      // debugger;
    var processs = $(this);
    $(this).find('.order_history').toggle();
    $(this).find('.ColumnProduct-imgs').toggle();
    setTimeout(function () {
      processs.find('.order_view_all .deliver_process .order_bar').addClass('animation_bar');
    }, 100);
  });   
  // setTimeout(function(){
  //   $(".product_gift_details").slick({
  //     slidesToShow: 2,
  //     slidesToScroll: 1,
  //     arrows: false,
  //     dots: true,
  //     infinite: false,
  //     responsive: [
  //       {
  //         breakpoint: 990,
  //         settings: {
  //           slidesToShow: 1
  //         }
  //       },
  //       {
  //         breakpoint: 768,
  //         settings: {
  //           slidesToShow: 2
  //         }
  //       },
  //       {
  //         breakpoint: 576,
  //         settings: {
  //           slidesToShow: 1
  //         }
  //       }
  //     ]
  //   });
  // }, 500);


});



